import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React from 'react';
import { List } from 'react-window';

function RowComponent({
    index,
    items,
    style,
    columnSize,
}) {
    const rowItems = items[index];
    return (
        <div style={style}>
            <Grid container spacing={1}>
                {rowItems.map((child, idx) => (
                    <Grid item size={12/columnSize} key={idx}>
                        {child}
                    </Grid>
                ))}
            </Grid>
        </div>
    );
}

function RpCheckboxGrid({columnSize = 2, children, width, maxRows}) {
    const childrenArray = React.Children.toArray(children);


    const chunkedChildren = Array.from(
        {length: Math.ceil(childrenArray.length / columnSize)},
        (_, i) => childrenArray.slice(i * columnSize, i * columnSize + columnSize)
    );

    const items = maxRows ? chunkedChildren.slice(0, maxRows) : chunkedChildren;

    return (
        <Box
            sx={{
                overflowY: maxRows ? 'visible' : 'auto',
                height: '100%',
            }}
        >
            <List
                rowComponent={RowComponent}
                rowCount={items.length}
                rowHeight={maxRows ? 50 : 60}
                rowProps={{
                    items,
                    columnSize
                }}
                style={maxRows ? { overflow: 'hidden' } : {}}
            />
        </Box>

    );
}

export default RpCheckboxGrid;